document.addEventListener("DOMContentLoaded", () => {
  // Prevent browser from automatically restoring scroll position, which can cause conflicts
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const scrollToHash = () => {
    const hash = window.location.hash;
    if (hash) {
      const targetId = hash.substring(1);
      // Handle special characters in ID if necessary
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // Use standard scrollIntoView. 
        // The theme's CSS (scroll-padding-block-start) should handle the sticky header offset.
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  // Initial scroll
  scrollToHash();
  setTimeout(scrollToHash, 100);

  // Retry after full window load to handle race conditions with other scripts
  window.addEventListener('load', () => {
    setTimeout(scrollToHash, 100);
    // Extra check for late-loading scripts
    setTimeout(scrollToHash, 500);
  });

  // Listen for hash changes
  window.addEventListener('hashchange', scrollToHash);
});
